import { render, staticRenderFns } from "./paystar.vue?vue&type=template&id=2d60b5b7&scoped=true"
import script from "./paystar.vue?vue&type=script&lang=js"
export * from "./paystar.vue?vue&type=script&lang=js"
import style0 from "./paystar.vue?vue&type=style&index=0&id=2d60b5b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60b5b7",
  null
  
)

export default component.exports